import { render, staticRenderFns } from "./QuestionTemplateProductsEditForm.vue?vue&type=template&id=534b0d1d&scoped=true&"
import script from "./QuestionTemplateProductsEditForm.vue?vue&type=script&lang=ts&"
export * from "./QuestionTemplateProductsEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionTemplateProductsEditForm.vue?vue&type=style&index=0&id=534b0d1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534b0d1d",
  null
  
)

export default component.exports